import React, { useCallback, useRef, useEffect, useState } from 'react';

import { IconType } from 'react-icons';
import { Feira, Expositor, Container } from './styles';
import { ContactIcons } from '../../components/Menu';
import { urlWebsite } from '../../config';
import api from '../../services/api';
import { Button } from '../../components/Button/styles';
import { Form } from '@unform/web';
import { useSearch } from '../../hooks/Search';
import { useAuth } from '../../hooks/Auth';
import QrReader from 'react-qr-reader';
import CheckinQRList from '../DashboardPages/features/CheckinQRList';
import { FaCheckCircle, FaQrcode } from 'react-icons/fa';
import { useToast } from '../../hooks/Toast';
import QRCodeCreator from './modules/QRCodeCreator';
interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

interface IExpositor {
  id: number;
  background: string;
  capa: string;
  title: string;
  link_name: string;
}

const Expositores: React.FC = () => {
  const { user } = useAuth();
  const [data, setData] = useState<Array<Record<string, any>>>([]);
  const [search, setSearch] = useState('');
  const [type, setType] = useState('qrcode');
  const { reloadSearchAll } = useSearch();
  const { addToast } = useToast();

  const load = async (searchString) => {
    if (user) {
      const dataItems = await api.get(`/students-list-presence`, {
        params: {
          search: searchString,

        }
      });
      setData(dataItems?.data?.rows);
    }
  };

  const confirmate = async (item) => {

    try {
      await api.post(`/confirm-student-access-simple/${item?.user_hash}/${user.project_id}`);
      load(search)
      addToast({ title: 'Presença confirmada!', type: 'success' })

    }
    catch (err) {
      addToast({ title: err?.response?.data?.message || err?.response?.data?.error || 'Erro ao confirmar usuário' })
    }


  }

  useEffect(() => {

    load(search);
  }, [search, type]);


  if (!user) {
    return <Container>
      <h2>Área restrita</h2>
    </Container>
  }

  return (
    <Container>
      {type !== 'qrcode' ? <button className='defaultButton' onClick={() => setType('qrcode')}>Gerar QRCode</button> : <></>}
      {type !== 'search' ? <button className='defaultButton' onClick={() => setType('search')}>Usar Pesquisa</button> : <button className='defaultButton' onClick={() => setType('search')}>Usar pesquisa</button>}

      {/* type !== 'camera' ? <button className='defaultButton' onClick={() => setType('camera')}>Usar câmera</button> : <button className='defaultButton' onClick={() => setType('canera')}>Usar câmera</button> */}


      {type === 'search' ? <aside style={{ width: '100%', maxWidth: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px', flexDirection: 'column' }}>
        <input style={{ padding: '15px', borderRadius: '10px', background: '#fff', margin: '15px auto' }} placeholder="Pesquisar" onChange={(e) => setSearch(e.target.value)} value={search} />

        {
          data?.map(item => {
            return <aside style={{ display: 'flex', alignItems: 'flex-start', width: '100%', background: '#fff', borderRadius: '10px', gap: '10px', padding: '15px' }} >

              <aside style={{ minWidth: '40px', alignSelf: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {item?.credentiated_list?.[user?.project_id] === 'yes' ? <FaQrcode onClick={() => confirmate(item)} style={{ width: '30px', height: '30px', color: 'green' }} /> : <FaQrcode onClick={() => confirmate(item)} style={{ width: '30px', height: '30px', cursor: 'pointer', color: '#ddd' }} />}
              </aside>
              <aside>
                <h2 style={{ color: '#333', width: '100%', textAlign: 'left' }}>Nome: {item.name}</h2>
                <p style={{ color: '#333', width: '100%', textAlign: 'left' }}>CPF: {item.document_number}</p>
                <p style={{ color: '#333', width: '100%', textAlign: 'left' }}>  {item.extra_1}</p>
              </aside>
            </aside>
          })
        }

      </aside> : <></>}

      {type === 'qrcode' ? <>


        <QRCodeCreator />

      </> : <></>}

      {type === 'camera' ? <>


        <CheckinQRList />

      </> : <></>}

    </Container>
  );
};
export default Expositores;
